import React, { useEffect, useMemo, useState } from 'react';
import Axios from 'axios';
import { Card } from 'react-bootstrap';
import config from '../../../../config';
import EmpenhoModal from './EmpenhoModal';
import ReportTable from './ReportTable';

const columns = [
  'id',
  'cliente_nome_abrev',
  'emenda_tipo_nome',
  'emenda_ep_codigo',
  'emenda_numero',
  'emenda_autor',
  'emenda_objeto',
  'empenho',
  'empenho_tipo_nome',
  'data_emissao',
  'data_liquidacao',
  'data_pagamento',
  'resumo_licitacao',
  'documento_fornecedor',
  'nome_fornecedor',
  'valor_atualizado',
  'valor_liquidado',
  'valor_pago',
  'cod_unidade_orcamentaria',
  'nome_unidade_orcamentaria',
  'cod_acao',
  'nome_acao',
  'cod_despesa',
  'nome_despesa',
  'cod_fonte_recurso',
  'nome_fonte_recurso',
  'historico',
];

function getDefaultFiltro() {
  const year = new Date().getFullYear();
  return {
    exercicio: year,
    periodoInicio: new Date(year, 0, 1),
    periodoFim: new Date(year, 11, 31),
  };
}

function parseFiltro(filtro, filtrosTela = {}) {
  const exercicio = filtrosTela.exercicio || filtro.exercicio;
  const parsed = [
    { sequencial_empenho: { $eq: 0 } },
    { exercicio: { $eq: Number(exercicio) } },
    { emenda_id: { $gt: 0 } },
  ];

  if (filtrosTela.unidadeJurisdicionada) {
    parsed.push({ cliente_nome_abrev: { $contains: filtrosTela.unidadeJurisdicionada } });
  }

  if (filtrosTela.tipo) {
    parsed.push({ emenda_tipo_nome: { $contains: filtrosTela.tipo } });
  }

  if (filtrosTela.numero) {
    parsed.push({ emenda_numero: { $contains: filtrosTela.numero } });
  }

  if (filtrosTela.autoria) {
    parsed.push({ emenda_autor: { $contains: filtrosTela.autoria } });
  }

  if (filtrosTela.objeto) {
    parsed.push({ emenda_objeto: { $contains: filtrosTela.objeto } });
  }

  return parsed;
}

export default function ExecucaoDespesaTab({ identificador, filtros, onReportChange }) {
  const filtro = useMemo(() => getDefaultFiltro(), []);
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [empenhoId, setEmpenhoId] = useState(null);

  useEffect(() => {
    let isValid = true;

    async function fetchReport() {
      if (!identificador) return;

      setLoading(true);
      setReport(null);

      try {
        let url = `${config.api_path}/public/v1/transparencia/despesa/${identificador}`;
        url += `?restos=false`;
        url += `&columns=${columns.join(';')}`;
        const exercicio = Number(filtros.exercicio || filtro.exercicio);
        const periodoInicio = new Date(exercicio, 0, 1);
        const periodoFim = new Date(exercicio, 11, 31);

        url += `&periodo_inicio=${periodoInicio.getTime()}`;
        url += `&periodo_fim=${periodoFim.getTime()}`;
        url += `&filter=${JSON.stringify(parseFiltro(filtro, filtros))}`;

        const res = await Axios.get(url);

        if (isValid && !res.data.error) {
          const reportData = res.data.data;
          setReport(reportData);
          if (onReportChange) onReportChange(reportData);
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (isValid) setLoading(false);
      }
    }

    fetchReport();

    return () => {
      isValid = false;
    };
  }, [filtro, identificador, filtros]);

  if (!identificador) {
    return (
      <Card className='my-2'>
        <Card.Body className='text-muted'>Identificador do portal não informado.</Card.Body>
      </Card>
    );
  }

  return (
    <>
      <EmpenhoModal identificador={identificador} id={empenhoId} onHide={() => setEmpenhoId(null)} />
      <ReportTable
        report={report}
        loading={loading}
        columnLabels={{
          cliente_nome_abrev: 'Unidade Jurisdicionada',
          emenda_numero: 'Número da Emenda',
          emenda_autor: 'Autor',
          emenda_objeto: 'Detalhamento do Objeto',
          emenda_tipo_nome: 'Tipo',
          emenda_ep_codigo: 'EP',
          valor_atualizado: 'Valor Atualizado - (Empenhado \\- Anulado + Reforçado)'
        }}
        onShowEmpenho={setEmpenhoId}
      />
    </>
  );
}
